module.exports = __webpack_public_path__ + "static/img/team3.d2a1fd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructors/team3.png
// module id = 1idj
// module chunks = 1